import { render } from "./ListaMiGente.vue?vue&type=template&id=315a83bd&ts=true"
import script from "./ListaMiGente.vue?vue&type=script&lang=ts"
export * from "./ListaMiGente.vue?vue&type=script&lang=ts"

import "./ListaMiGente.vue?vue&type=style&index=0&id=315a83bd&lang=scss"

import exportComponent from "/home/rdimicheleb/Repos/AMII/apps/app-paciente/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__